/**
 * This feature's routes, as constants.
 *
 * Separate from `routes.tsx` so a screen can link to another without importing
 * the module that builds the route table — which would be a cycle.
 */

export const ORDERS_PATHS = {
  orders: "/commandes",
  quotes: "/devis",
  order: "/commandes/$id",
  policy: "/commandes/parametres",
} as const;
